export default __webpack_public_path__ + "static/media/porta7511.c7f8bafc.mp4";